import React, { Component } from 'react'
import Icon from 'svg-inline-react'
import * as CONSTANTS from 'app/modules/rules/constants'

const closeSRC = require('!svg-inline?removeTags=true!images/icons/times-icon.svg')

class HeadquarterPostalCodeFilter extends Component {

  constructor(props) {
    super(props)

    const { value, field } = props.activeFilter

    this.state = {
      currentPostalCode: '',
      postalCodes: value || [],
      fieldType: field,
    }
  }

  removePostalCode = (value) => {
    this.setState((prevState) => {
      return {
        postalCodes: _.without(prevState.postalCodes, value)
      }
    }, this.updateCondition)
  }

  updateCurrentPostalCode = (event) => {
    this.setState({
      currentPostalCode: event.target.value
    })
  }

  savePostalCode = () => {
    this.setState((prevState) => {
      if (_.includes(prevState.postalCodes, this.state.currentPostalCode)) {
        return {
          currentPostalCode: '',
          postalCodes: prevState.postalCodes
        }
      } else {
        const newOptions = [...prevState.postalCodes, this.state.currentPostalCode]
        newOptions.sort()
        return {
          currentPostalCode: '',
          postalCodes: newOptions
        }
      }
    }, this.updateCondition)
  }

  updateCondition = () => {
    const updatedCondition = {
      operator: CONSTANTS.CATEGORY_FILTER_OPERATORS.IS_ANY,
      value: this.state.postalCodes
    }

    this.props.onUpdateCondition(updatedCondition)
  }

  getListHeight() {
    const itemHeight = 75
    const totalColumns = 2
    const maxHeight = (this.state.postalCodes.length * itemHeight) / totalColumns + itemHeight
    return {
      height: `${maxHeight}px`
    }
  }

  renderTagSelectionList = () => {
    return (
      <ul style={this.getListHeight()} >
        {
          this.state.postalCodes.map((option, index) => {
            return (<li key={`${option}-${index}`}><span>{option}</span> <Icon src={closeSRC} className="remove" onClick={() => this.removePostalCode(option)}></Icon></li>)
          })
        }
      </ul>
    )
  }

  render() {
    return (
      <div className="rules-choice-content drift-form">
        <div className="rules-choice-options">
          <input type="text" value={this.state.currentPostalCode} onChange={this.updateCurrentPostalCode} className="large postal-code-input" placeholder="value" onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.savePostalCode()
            }
          }} />
          {this.state.currentPostalCode && <span className="postal-code-option-add" onClick={this.savePostalCode}>+Add</span>}
        </div>

        <div className="rules-choice-selection rules-choice-selection-multi-column">
          {this.renderTagSelectionList()}
        </div>
      </div>
    )
  }
}

export default HeadquarterPostalCodeFilter



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/FirmographicFilter/HeadquarterPostalCodeFilter.js